// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2PYUO","productName":"Table_productName__21jcn"};